<script setup lang="ts">
import usePoolStore from '~/store/pool'
import type { Network } from '~/interfaces/poolDetail'

const { locale } = useI18n()
const poolStore = usePoolStore()

const onClickOnNetworkName = () => {
    if (poolStore.getNetwork) {
        if (window.location !== window?.parent?.location) {
            ;(window.top as Window).postMessage(
                {
                    action: 'openUrl',
                    url: `networks/${(poolStore.getNetwork as Network)?.slug}`
                },
                document.referrer
            )
        } else {
            const newWnd = window.open(
                getChargemapUrl(
                    `/networks/${(poolStore.getNetwork as Network)?.slug}`,
                    locale.value
                ),
                '_top'
            )

            if (newWnd) {
                newWnd.opener = null
            }
        }
    }
}
</script>

<template>
    <div class="text-gray-l-500 text-0.5sm flex my-4">
        <span class="w-1/2 block">
            {{ $t('word.network') }}
        </span>
        <span
            class="text-secondary-info cursor-pointer"
            @click="onClickOnNetworkName"
        >
            {{ poolStore.getNetworkName }}
        </span>
    </div>
</template>
